export interface OptionalUpgrade {
  _id: string;
  builderId: string;
  includedItems: string[];
  url: string;
  price: number;
  name: string;
}

export interface CreateOptionalUpgradeInterface {
  builderId: string;
  includedItems: string[];
  url: string;
  price: number;
  name: string;
}

export interface QueryOptionalUpgradeInterface {
  builderId?: string;
  name?: string;
  price?: number;
}

export interface UpdateOptionalUpgradeInterface {
  includedItems?: string[];
  url?: string;
  price?: number;
  name?: string;
}

export const optionalUpgradeDefault: OptionalUpgrade = {
  _id: "",
  builderId: "",
  includedItems: [],
  url: "",
  price: 0,
  name: "",
};
